export default __webpack_public_path__ + "static/media/registration-3960205_640.8ae6175e.jpg";